import { all } from "redux-saga/effects";
import loginSaga from "./loginSaga";
import preLoginSaga from "./preLoginSaga";
import sessionSaga from "./sessionSaga";
import logoutSaga from "./logoutSaga";

export default function* rootSaga() {
  yield all([loginSaga(), preLoginSaga(), sessionSaga(), logoutSaga()]);
}